import { LocaleContext } from 'context/locale';
import { Translator } from 'context/locale/LocaleContext/LocaleContext.types';
import { useContext } from 'react';

export const useTranslator = (): Translator => {
  return useContext(LocaleContext).trans;
};
